module.exports = __webpack_public_path__ + "static/media/reservarcannabis-logo_preto.0bf83a1e.png";